///////////////////////////////////////////////////////////
// Geocoding / address autocomplete bias configuration  //
///////////////////////////////////////////////////////////

// Strategy for biasing address autocomplete suggestions.
// Applied to both the search bar location field and the sell-form pickup address field.
//
//   'ip': proximity to user's detected IP location only
//   'region': bias to regionBounds only, ignore IP
//   'ip-then-region': bias toward IP location first; regionBounds used as the
//                      soft fallback rectangle so results don't drift globally
//                      when IP proximity is weak (e.g. VPN users)
export const biasStrategy = 'ip-then-region';

// Bounding box for the regional fallback (or sole bias when strategy is 'region').
// Decimal degrees. Default: NY / Eastern US corridor (NY, NJ, CT, PA, MA, etc.)
export const regionBounds = {
  north: 47.0,
  south: 36.0,
  east: -67.0,
  west: -82.0,
};

// ISO 3166-1 alpha-2 country codes to restrict results to.
export const countryCodes = ['US'];
